import React from 'react';
import { Link } from 'react-router-dom';

import '../../utils/styles/Arsenal.css';
import Menu from '../../assets/arsenal/week-dishes.jpg';
import Brasserie from '../../assets/arsenal/brasserie-dishes.jpg';
import Snacks from '../../assets/arsenal/snacks.jpg';
import Desserts from '../../assets/arsenal/desserts.jpg';
import Drinks from '../../assets/arsenal/drinks.jpg';
import Special from '../../assets/arsenal/special-dishes.png';

import ArsenalSchedule from '../../components/Arsenal/ArsenalSchedule';

function Arsenal() {
    return (
        <div className="container">
            <ArsenalSchedule />

            <div id="all-menu">
                <Link to="/arsenal/menu-de-la-semaine" className="menu-card">
                    <img src={Menu} alt="menu" />
                    <span className="title-2">Menu de la semaine</span>
                </Link>

                <Link to="/arsenal/plats-brasserie" className="menu-card">
                    <img src={Brasserie} alt="brasserie" />
                    <span className="title-2">Plats brasserie</span>
                </Link>

                <Link to="/arsenal/snacks" className="menu-card">
                    <img src={Snacks} alt="snacks" />
                    <span className="title-2">Snacks</span>
                </Link>

                <Link to="/arsenal/desserts" className="menu-card">
                    <img src={Desserts} alt="desserts" />
                    <span className="title-2">Desserts</span>
                </Link>

                <Link to="/arsenal/boissons" className="menu-card">
                    <img src={Drinks} alt="boissons" />
                    <span className="title-2">Boissons</span>
                </Link>

                <Link to="/arsenal/plats-exclusifs" className="menu-card">
                    <img src={Special} alt="plats exclusifs" />
                    <span className="title-2">Plats exclusifs</span>
                </Link>
            </div>
        </div>
    );
}

export default Arsenal;
